import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { Grid, RadioGroup } from "@mui/material";
import { Info } from "@mui/icons-material";
import {
  BillingRadioControlDropdown,
  NewReqInsuranceHeader,
  NewReqSecondaryButton,
  NewReqSecondaryInsuranceLabel,
  NewReqSecondaryInsuranceWrapper,
  NewReqTooltip,
  NewReqTooltipContent,
} from "./NewRequisition.styles";
import { currentNewRequisitionEdit } from "../../recoil/atoms";

import NewReqBillToInsuranceAttach from "./NewReqBillToInsuranceAttach";
import NewReqBillToInsuranceUpload from "./NewReqBillToInsuranceUpload";
import NewReqBillToInsuranceEntry from "./NewReqBillToInsuranceEntry";
import NewReqFileUploader, { FileUploadInfo } from "./NewReqFileUploader";

const NewReqBillToInsurance: React.FC<{ preflight: boolean }> = ({
  preflight,
}) => {
  const [newRequisition, setNewRequisition] = useRecoilState(
    currentNewRequisitionEdit,
  );
  const [isFileUploadProcessing, setFileUploadProcessing] = useState(false);
  const { requisitionForm } = newRequisition;
  const [showSecondaryInsurance, setShowSecondaryInsurance] = useState(
    preflight ||
      Boolean(
        Object.keys(requisitionForm.insuranceFileUrlsSecondaryFront).length,
      ) ||
      Boolean(
        Object.keys(requisitionForm.insuranceFileUrlsSecondaryBack).length,
      ),
  );
  return (
    <>
      <div>
        <NewReqInsuranceHeader>Insurance Information</NewReqInsuranceHeader>
        <BillingRadioControlDropdown $hideBorder>
          <RadioGroup
            value={requisitionForm.billToInsuranceType}
            onChange={(e) =>
              setNewRequisition({
                ...newRequisition,
                requisitionForm: {
                  ...newRequisition.requisitionForm,
                  billToInsuranceType: e.target.value as
                    | "Entry"
                    | "Attach"
                    | "Upload",
                },
              })
            }
          >
            {requisitionForm.isInsuranceSheetAccount && (
              // ATTACH
              <NewReqBillToInsuranceAttach />
            )}
            {
              // UPLOAD
              <NewReqBillToInsuranceUpload />
            }
            {
              // ENTRY
              <NewReqBillToInsuranceEntry />
            }
          </RadioGroup>
        </BillingRadioControlDropdown>
        {((newRequisition.preflight &&
          Boolean(
            Object.keys(requisitionForm.insuranceFileUrlsSecondaryFront).length,
          )) ||
          Boolean(
            Object.keys(requisitionForm.insuranceFileUrlsSecondaryBack).length,
          ) ||
          !newRequisition.preflight) && (
          <>
            <NewReqSecondaryInsuranceLabel>
              <NewReqInsuranceHeader
                style={{ marginTop: "30px", marginBottom: "14px" }}
              >
                Optional Secondary Information
              </NewReqInsuranceHeader>{" "}
              <NewReqTooltip
                PopperProps={{
                  sx: {
                    "& .MuiTooltip-tooltip": {
                      backgroundColor: "white",
                      boxShadow: "0px 10px 20px rgb(0 0 0 / 10%)",
                      zIndex: 100000,
                    },
                  },
                }}
                title={
                  <NewReqTooltipContent>
                    Secondary insurance typically pays for costs not covered or
                    fully covered by primary insurance, such as deductibles,
                    copayments, and out-of-pocket expenses.
                  </NewReqTooltipContent>
                }
              >
                <Info />
              </NewReqTooltip>
            </NewReqSecondaryInsuranceLabel>
            {showSecondaryInsurance ? (
              <Grid item xs={12}>
                <NewReqSecondaryInsuranceWrapper>
                  <div>
                    <NewReqInsuranceHeader>
                      Front of Insurance Card<span>*</span>
                    </NewReqInsuranceHeader>{" "}
                    <NewReqFileUploader
                      type="insurance"
                      insuranceType="secondary"
                      cardType="front"
                      value={requisitionForm.insuranceFileUrlsSecondaryFront}
                      setValue={(files: FileUploadInfo) => {
                        setNewRequisition({
                          ...newRequisition,
                          requisitionForm: {
                            ...newRequisition.requisitionForm,
                            insuranceFileUrlsSecondaryFront: files,
                          },
                        });
                      }}
                      uploadProcessing={isFileUploadProcessing}
                      setUploadProcessing={setFileUploadProcessing}
                      preflight={newRequisition.preflight}
                    />
                  </div>
                  <div>
                    <NewReqInsuranceHeader>
                      Back of Insurance Card<span>*</span>
                    </NewReqInsuranceHeader>{" "}
                    <NewReqFileUploader
                      type="insurance"
                      insuranceType="secondary"
                      cardType="back"
                      value={requisitionForm.insuranceFileUrlsSecondaryBack}
                      setValue={(files: FileUploadInfo) => {
                        setNewRequisition({
                          ...newRequisition,
                          requisitionForm: {
                            ...newRequisition.requisitionForm,
                            insuranceFileUrlsSecondaryBack: files,
                          },
                        });
                      }}
                      uploadProcessing={isFileUploadProcessing}
                      setUploadProcessing={setFileUploadProcessing}
                      preflight={newRequisition.preflight}
                    />
                  </div>
                </NewReqSecondaryInsuranceWrapper>
                {!preflight && (
                  <NewReqSecondaryButton
                    onClick={() => {
                      setShowSecondaryInsurance(false);
                      setNewRequisition({
                        ...newRequisition,
                        requisitionForm: {
                          ...newRequisition.requisitionForm,
                          insuranceFileUrlsSecondaryFront: {},
                          insuranceFileUrlsSecondaryBack: {},
                        },
                      });
                    }}
                  >
                    Remove secondary insurance
                  </NewReqSecondaryButton>
                )}
              </Grid>
            ) : (
              <>
                {!preflight && (
                  <NewReqSecondaryButton
                    onClick={() => setShowSecondaryInsurance(true)}
                    style={{ marginTop: "0px" }}
                  >
                    Add secondary insurance
                  </NewReqSecondaryButton>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default NewReqBillToInsurance;
